import { proxy } from 'valtio';

const salzabbauTimebarState = proxy({
  areaActive: false,
  splinePoint: 1,
});

export default salzabbauTimebarState;
